import { useEffect } from 'react';

import {
  getPartnerApplicationSnapshot,
  PartnerApplicationMachineContext,
} from '~domains/partner-application/entities/application';
import { AgentsBlock } from '~domains/partner-application/widgets/agents-block';
import { BusinessBlock } from '~domains/partner-application/widgets/business-block';
import { PartnerApplicationFormNavigationConnected } from '~domains/partner-application/widgets/partner-application-form-navigation';
import { Review } from '~domains/partner-application/widgets/review-block';
import { StoresBlock } from '~domains/partner-application/widgets/stores-block';

import { AddressSuggestionApiProvider } from '~platform/entities/address-suggestion';

type Snapshot = Awaited<ReturnType<typeof getPartnerApplicationSnapshot>>;

type PartnerApplicationProps = {
  snapshot?: Snapshot;
};

export const PartnerApplication = ({
  snapshot,
}: PartnerApplicationProps = {}) => {
  return (
    <PartnerApplicationMachineContext.Provider
      options={snapshot ? { snapshot } : undefined}
    >
      <AddressSuggestionApiProvider>
        <PartnerApplicationFormNavigationConnected />
        <PartnerApplicationFlow />
      </AddressSuggestionApiProvider>
    </PartnerApplicationMachineContext.Provider>
  );
};

const PartnerApplicationFlow = () => {
  const state = PartnerApplicationMachineContext.useSelector(
    (snapshot) => snapshot
  );
  const actor = PartnerApplicationMachineContext.useActorRef();

  useEffect(() => {
    actor.send({ type: 'ping' });
  }, []);

  if (state.matches('businessBlock')) return <BusinessBlock />;
  if (state.matches('storesBlock')) return <StoresBlock />;
  if (state.matches('agentsBlock')) return <AgentsBlock />;
  if (state.matches('review')) return <Review />;
  if (state.matches('submitted')) return <SubmittedScreen />;

  return null;
};

const SubmittedScreen = () => (
  <div
    className={`
      flex h-full min-h-screen flex-col items-center justify-center p-4
    `}
  >
    <div className="flex flex-col items-center gap-4 text-center">
      <h1 className="text-2xl font-bold">Application Submitted!</h1>
      <p className="text-gray-500">
        Your partner application has been submitted successfully. We will review
        it and get back to you soon.
      </p>
    </div>
  </div>
);
